import React from 'react';
import { render } from 'react-dom';
import { browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import Router from './router';
import configureStore from './store/configureStore';

import './index.scss';

const store = configureStore();
const history = syncHistoryWithStore(browserHistory, store);

const rootElement = document.getElementById('root');

let app;

if (module.hot) {
  const { AppContainer } = require('react-hot-loader'); // eslint-disable-line global-require
  app = (
    <AppContainer>
      <Router store={store} history={history} />
    </AppContainer>
  );

  module.hot.accept('./router', () => {
    const NewRoot = require('./router').default; // eslint-disable-line global-require

    render(
      <AppContainer>
        <NewRoot store={store} history={history} />
      </AppContainer>,
      rootElement
    );
  });
} else {
  app = <Router store={store} history={history} />;
}

render(app, rootElement);
